<template>
    <!-- 推广海报 -->
    <ZhaiHead></ZhaiHead>
    <div class="container-fluid zhu px-0">
        <div class="row shengse">
            <!-- 顶部栏 -->
            <div class="dixian px-4 topbar" ref="topBar">
                <div class="top-left" @click="goBack">‹</div>
                <div class="top-title">推广素材</div>
                <div class="top-right"></div>
            </div>

            <div class="poster-body">
                <!-- tip -->
                <div class="poster-tip" ref="posterTip">请截图保存推广素材</div>

                <!-- ✅ 展示用海报（适配手机屏幕） -->
                <div class="poster-wrap edge">
                    <div class="poster poster-preview" ref="posterPreview">
                        <img class="poster-bg" :src="currentBg" alt="" />

                        <!-- ✅ 展示用二维码（独立定位） -->
                        <div class="qr qr-preview" v-if="qrDataUrl">
                            <img :src="qrDataUrl" alt="qr" />
                        </div>
                    </div>
                </div>

                <!-- 1~7 选择 -->
                <div class="dots">
                    <div
                            v-for="n in 7"
                            :key="n"
                            class="dot"
                            :class="{ active: styleIndex === n }"
                            @click="styleIndex = n"
                    >
                        {{ n }}
                    </div>
                </div>

                <!-- 生成按钮 -->
                <button class="gen-btn" :disabled="generating" @click="onGenerate">
                    {{ generating ? "生成中..." : "生成推广图" }}
                </button>

                <!-- 点击生成后出现，关闭弹窗不消失 -->
                <div class="save-tip" v-if="showSaveTip">如无法下载图片 截图保存即可</div>

                <!-- 说明（可删） -->
                <!--<div class="placeholder">-->
                    <!--<div class="ph-title">开发期占位说明</div>-->
                    <!--<div class="ph-text">-->
                        <!--当前二维码内容使用：-->
                        <!--<span class="mono">{{ qrValue }}</span>-->
                        <!--<br />-->
                        <!--后端有真实落地页后，替换成真实推广地址即可。-->
                    <!--</div>-->
                <!--</div>-->
            </div>
        </div>
    </div>

    <!-- ✅ 隐藏：生成专用海报（固定 750×1334） -->
    <div class="poster poster-gen" ref="posterGen" aria-hidden="true">
        <img class="poster-bg" :src="currentBg" alt="" />

        <!-- ✅ 生成用二维码（独立定位） -->
        <div class="qr qr-gen" v-if="qrDataUrl">
            <img :src="qrDataUrl" alt="qr" />
        </div>
    </div>

    <!-- ✅ 生成结果弹窗 -->
    <div
            v-if="posterModal.visible"
            class="poster-mask"
            :style="{ paddingTop: posterModal.top + 'px' }"
            @click.self="closePosterModal"
    >
        <div class="poster-modal">
            <div class="poster-preview-modal">
                <div class="poster-img-wrap">
                    <img class="poster-img" :src="generatedImg" alt="poster" />
                </div>

                <button class="float-btn btn-close" @click="closePosterModal">关闭</button>
                <a class="float-btn btn-download" :href="generatedImg" download="poster.png">
                    下载
                </a>
            </div>
        </div>
    </div>

    <ZhaiFoot></ZhaiFoot>

    <!-- ✅✅ 允许追加：生成中遮罩（不改变原布局层级，仅追加到末尾） -->
    <div v-if="generating" class="gen-mask" aria-hidden="true">
        <div class="gen-mask-card">
            <div class="gen-spinner"></div>
            <div class="gen-text">海报生成中…</div>
        </div>
    </div>
</template>

<script>
    import ZhaiHead from "../components/ZhaiHead";
    import ZhaiFoot from "../components/ZhaiFoot";
    import html2canvas from "html2canvas";
    import QRCode from "qrcode";

    export default {
        name: "MPromotionPoster",
        components: { ZhaiHead, ZhaiFoot },
        data() {
            return {
                styleIndex: 1,
                generating: false,

                generatedImg: "",
                showSaveTip: false,

                posterModal: {
                    visible: false,
                    top: 120,
                },

                qrValue: "",
                qrDataUrl: "",

                bgList: [
                    require("../assets/pop1.jpg"),
                    require("../assets/pop2.jpg"),
                    require("../assets/pop3.jpg"),
                    require("../assets/pop4.jpg"),
                    require("../assets/pop5.jpg"),
                    require("../assets/pop6.jpg"),
                    require("../assets/pop7.jpg"),
                ],
            };
        },
        computed: {
            currentBg() {
                const idx = Math.max(1, Math.min(7, Number(this.styleIndex || 1))) - 1;
                return this.bgList[idx];
            },
        },
        async created() {
            const fromQuery = (this.$route && this.$route.query && this.$route.query.link) || "";
            this.qrValue = fromQuery || "https://placeholder.example.com/?uid=xxxxxx";
            await this.makeQr();
        },
        beforeUnmount() {
            document.body.style.overflow = "";
            document.body.style.cursor = "";
        },
        methods: {
            goBack() {
                if (window.history.length > 1) window.history.back();
                else this.$router.push({ path: "/Promotion" });
            },

            // ====== modal top（保留原逻辑）======
            calcModalTop() {
                const topBarEl = this.$refs.topBar;
                const tipEl = this.$refs.posterTip;

                let top = 0;
                if (topBarEl && topBarEl.getBoundingClientRect) {
                    top = Math.max(top, Math.ceil(topBarEl.getBoundingClientRect().bottom));
                }
                if (tipEl && tipEl.getBoundingClientRect) {
                    top = Math.max(top, Math.ceil(tipEl.getBoundingClientRect().bottom));
                }
                top += 6;
                if (top < 60) top = 60;
                return top;
            },

            openPosterModal() {
                this.posterModal.visible = true;
                document.body.style.overflow = "hidden";
                this.$nextTick(() => {
                    this.posterModal.top = this.calcModalTop();
                });
            },

            closePosterModal() {
                this.posterModal.visible = false;
                document.body.style.overflow = "";
                document.body.style.cursor = "";
            },

            // ====== QR：对齐 PC 的参数（清晰、白底、无 margin、纠错H）======
            async makeQr() {
                try {
                    const text = this.qrValue || "https://placeholder.example.com/";
                    this.qrDataUrl = await QRCode.toDataURL(text, {
                        margin: 0,
                        width: 420,
                        errorCorrectionLevel: "H",
                        color: {
                            dark: "#000000",
                            light: "#FFFFFF",
                        },
                    });
                } catch (e) {
                    console.error("二维码生成失败：", e);
                    this.qrDataUrl = "";
                }
            },

            // ====== 生成：对齐 PC（锁定策略/try finally/弹窗打开不恢复滚动）======
            async onGenerate() {
                if (this.generating) return;
                this.generating = true;

                // ✅ 生成期间：锁定页面 + wait 光标（与 PC 一致）
                document.body.style.overflow = "hidden";
                document.body.style.cursor = "wait";

                try {
                    if (!this.qrDataUrl) {
                        await this.makeQr();
                        await this.$nextTick();
                    }

                    const el = this.$refs.posterGen;
                    if (!el) {
                        alert("生成失败：posterGen 不存在");
                        return;
                    }

                    await this.$nextTick();
                    await new Promise((r) => requestAnimationFrame(() => r()));

                    const canvas = await html2canvas(el, {
                        useCORS: true,
                        backgroundColor: null,
                        scale: 2,
                    });

                    this.generatedImg = canvas.toDataURL("image/png");
                    this.showSaveTip = true;
                    this.openPosterModal();
                } catch (e) {
                    console.error(e);
                    alert("生成失败，请稍后重试");
                } finally {
                    this.generating = false;

                    // ✅ 如果弹窗没打开才恢复滚动；弹窗打开继续锁（与 PC 一致）
                    if (!this.posterModal.visible) {
                        document.body.style.overflow = "";
                    }
                    document.body.style.cursor = "";
                }
            },
        },
    };
</script>

<style scoped>
    /* 页面结构 */
    .zhu {
        margin-top: 75px;
        height: calc(100vh - 80px);
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }
    .shengse {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
    }

    /* 顶部栏 */
    .topbar {
        display: grid;
        grid-template-columns: 20px 1fr 20px;
        align-items: center;
        background: #ff6b6b;
        color: #fff;
    }
    .top-left {
        font-size: 30px;
        text-align: left;
        cursor: pointer;
        user-select: none;
    }
    .top-title {
        text-align: center;
        font-size: 18px;
        font-weight: 800;
    }
    .top-right {
        width: 40px;
    }

    /* 页面背景 */
    .poster-body {
        flex: 1;
        overflow-y: auto;
        background: linear-gradient(180deg, #ff6b6b 0%, #ffd1e8 45%, #d9f5db 100%);
        padding-bottom: 26px;
    }
    .poster-tip {
        text-align: center;
        color: #111;
        font-size: 18px;
        font-weight: 800;
        padding: 2px 10px 1px;
    }

    /* 海报展示区域：贴边 */
    .poster-wrap.edge {
        padding: 0;
        margin: 0;
    }

    /* ✅ 展示用海报（适配屏幕） */
    .poster-preview {
        position: relative;
        width: 100%;
        height: 61vh;
        overflow: hidden;
        background: transparent;
    }
    .poster-preview .poster-bg {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
        object-position: top center;
    }

    /* ✅ 生成用海报（固定750×1334） */
    .poster-gen {
        position: fixed;
        left: -99999px;
        top: 0;
        width: 750px;
        height: 1334px;
        overflow: hidden;
        background: transparent;
    }
    .poster-gen .poster-bg {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
        object-position: top center;
    }

    /* ✅ 二维码通用基础（仅负责“形状/层级”） */
    .qr {
        position: absolute;
        aspect-ratio: 1 / 1;
        padding: 1.2%;
        box-sizing: border-box;
        z-index: 10;
    }
    .qr img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
    }

    /* ✅ 展示区二维码：百分比定位（适配各种手机） */
    .qr-preview {
        right: 12%;
        bottom: 0%;
        width: 22%;
    }

    /* ✅ 生成区二维码：固定落点 */
    .qr-gen {
        right: 5px;
        bottom: 0px;
        width: 200px;
    }

    /* 1~7 */
    .dots {
        display: flex;
        justify-content: center;
        gap: 10px;
        padding: 18px 14px 10px;
    }
    .dot {
        width: 38px;
        height: 38px;
        border-radius: 999px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.55);
        color: rgba(255, 0, 0, 0.55);
        font-weight: 900;
        user-select: none;
        cursor: pointer;
    }
    .dot.active {
        background: #fff;
        color: #e53935;
        border: 2px solid rgba(229, 57, 53, 0.25);
    }

    /* 生成按钮 */
    .gen-btn {
        display: block;
        width: 240px;
        height: 52px;
        margin: 10px auto 0;
        border: 0;
        border-radius: 999px;
        background: #ffd500;
        color: #fff;
        font-size: 18px;
        font-weight: 900;
        cursor: pointer;
    }
    .gen-btn:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }

    /* 提示 */
    .save-tip {
        margin: 12px 14px 0;
        text-align: center;
        padding: 10px 12px;
        border-radius: 10px;
        background: rgba(255, 255, 255, 0.65);
        font-size: 15px;
        font-weight: 900;
        color: #e53935;
    }

    /* 占位说明 */
    .placeholder {
        margin: 14px 14px 0;
        background: rgba(255, 255, 255, 0.55);
        border-radius: 10px;
        padding: 12px;
    }
    .ph-title {
        font-weight: 900;
        margin-bottom: 6px;
        color: #111;
    }
    .ph-text {
        font-size: 13px;
        color: #333;
        line-height: 1.6;
    }
    .mono {
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
        "Courier New", monospace;
        font-weight: 800;
    }

    /* ✅ 弹窗遮罩 */
    .poster-mask {
        position: fixed;
        inset: 0;
        z-index: 99999;
        background: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-left: 18px;
        padding-right: 18px;
        padding-bottom: 18px;
    }

    /* 弹窗容器 */
    .poster-modal {
        width: 100%;
        max-width: 520px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .poster-preview-modal {
        width: 100%;
        position: relative;
    }

    /* 预览图片容器 */
    .poster-img-wrap {
        width: 100%;
        background: #fff;
        border-radius: 0;
        overflow: hidden;
        box-shadow: 0 18px 60px rgba(0, 0, 0, 0.35);
        max-height: calc(100vh - 170px);
    }

    /* 图片 */
    .poster-img {
        width: 100%;
        display: block;
        height: auto;
        border-radius: 0;
    }

    /* 文字圆按钮 */
    .float-btn {
        position: absolute;
        width: 64px;
        height: 64px;
        border-radius: 999px;
        border: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 900;
        color: #fff;
        cursor: pointer;
        user-select: none;
        text-decoration: none;
        box-shadow: 0 16px 36px rgba(0, 0, 0, 0.35);
        z-index: 10;
    }
    .btn-close {
        left: 12px;
        background: #ff4d4f;
    }
    .btn-download {
        right: 12px;
        background: #2d8cff;
    }
    .float-btn:active {
        transform: scale(0.98);
        opacity: 0.9;
    }

    /* ✅✅ 新增：生成中遮罩（仅追加，不影响原布局结构） */
    .gen-mask {
        position: fixed;
        inset: 0;
        z-index: 100000; /* 比 poster-mask 更高，生成时确保盖住 */
        background: rgba(0, 0, 0, 0.45);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 18px;
    }
    .gen-mask-card {
        width: 240px;
        background: rgba(255, 255, 255, 0.95);
        border-radius: 14px;
        padding: 18px 14px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        box-shadow: 0 18px 60px rgba(0, 0, 0, 0.25);
    }
    .gen-spinner {
        width: 34px;
        height: 34px;
        border-radius: 999px;
        border: 3px solid rgba(0, 0, 0, 0.12);
        border-top-color: rgba(0, 0, 0, 0.55);
        animation: genSpin 0.8s linear infinite;
    }
    .gen-text {
        font-size: 14px;
        font-weight: 900;
        color: #111;
    }
    @keyframes genSpin {
        to {
            transform: rotate(360deg);
        }
    }
</style>
